import api from "@/api";

export default {
    getAllByWorkspaceId(workspaceId,params) {
        return api.get(`/api/workspaces/${workspaceId}/columns`, { params });
    },
    create(workspaceId, columnData) {
        return api.post(`/api/workspaces/${workspaceId}/columns`, columnData);
    },
    update(workspaceId, columnId, columnData) {
        return api.put(`/api/workspaces/${workspaceId}/columns/${columnId}`, columnData);
    },
    deleteById(workspaceId, columnId) {
        return api.delete(`/api/workspaces/${workspaceId}/columns/${columnId}`);
    },
    assignUsersToColumn(workspaceId, columnId, userIds) {
        return api.post(`/api/workspaces/${workspaceId}/columns/${columnId}/assign-users`, userIds);
    },
    syncTasks (workspaceId, columnId){
        return api.post(`/api/workspaces/${workspaceId}/columns/${columnId}/sync-tasks`);
    },
    archiveAllTask (workspaceId, columnId){
        return api.post(`/api/workspaces/${workspaceId}/columns/${columnId}/archive-all-tasks`);
    },
    clone(workspaceId, columnId) {
        return api.post(`/api/workspaces/${workspaceId}/columns/${columnId}/clone`);
    }
};